import { useInfiniteQuery } from '@tanstack/react-query'
import { useSpecificCategory } from '@zet/common/hooks/useSpecificCategory'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { APP_NAME } from '@zet/end-points'

import { fetchLeads } from '../functions'
import { fetchAdvisorLeads } from '../functions/fetchAdvisorLeads'

// TODO: Fix this with the category specific leads

interface IProps {
  searchText?: string
  leadsType?: string
  limit?: number
}

function useLeads({ searchText, leadsType, limit = 10 }: IProps) {
  const { category } = useSpecificCategory()

  return useInfiniteQuery(
    ['leads', { searchText, limit, leadsType }],
    ({ pageParam = 0 }) => {
      return APP_NAME === MY_TEAMS_ADVISOR
        ? fetchAdvisorLeads(
            pageParam || 0,
            searchText,
            leadsType || '',
            limit,
            category
          )
        : fetchLeads(pageParam || 0, searchText, leadsType || '', limit)
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage, pages) => {
        if (APP_NAME === MY_TEAMS_ADVISOR) {
          return pages?.length * 10 < lastPage?.count
            ? lastPage?.nextOffset
            : undefined
        }

        return lastPage?.count >= limit
          ? lastPage?.nextOffset ?? false
          : undefined
      },
    }
  )
}

export { useLeads }
